import { styled, Box, FormControl, StyleSystemProps } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledSaveButton = styled(Box)``;
const saveButtonStyles: StyleSystemProps = {
  _hover: { backgroundColor: 'mono12' },
  _active: { backgroundColor: 'mono13' },
  height: pxToRem(40),
  backgroundColor: 'mono14',
  width: '100%',
  color: 'white',
  borderRadius: 2,
  flex: '1 1 50%',
};

export const StyledFormControl = styled(FormControl)``;
const formControlStyles: CSSObject = {
  height: pxToRem(40),
  marginRight: 5,
  flex: '1 1 50%',
  input: {
    textAlign: 'center',
  },
};

const cancelHoverStyles = {
  color: 'mono5',
  backgroundColor: 'transparent',
};

const cancelActiveStyles = {
  color: 'mono7',
  backgroundColor: 'transparent',
};

export const styles = {
  saveButton: saveButtonStyles,
  formControl: formControlStyles,
  cancelHover: cancelHoverStyles,
  cancelActive: cancelActiveStyles,
};
